if (typeof(window.nonPOSPage) == 'undefined' || !window.nonPOSPage) {
    //we expose jquery to the global window scope, so all modules can access it
    require('expose-loader?$!expose-loader?jQuery!jquery');
    require("bootstrap-webpack");

    require("script-loader!./lib/sockjs.min");
    require("script-loader!./lib/stomp.min");

    require("./css_modules/settings.less");
    require("./css_modules/numberPad.less");
    require("./css_modules/pos.less");
    require("./css_modules/overview.less");
    require("./css_modules/order.less");
    require("./css_modules/table.less");
    require("./css_modules/notification.less");
    require("./css_modules/cashier.less");
    require("./lib/animate.css/animate.css");
    require("./lib/jqueryui/jquery-ui-1.10.4.custom.min.css");

    require('./css/mobile-pos.less');
    require('./css/mobile-cashier.less');
    require('./css/mobile-order.less');
    require('./css/mobile-table.less');
    require('./css/mobile-overview.less');
    require('./css/mobile-sales.less');
    require('./css/mobile-settings.less');

    require("form-serializer");

    // Global: Javascript
    require("script-loader!./lib/jqueryui/jquery-ui-1.10.4.custom.min.js");

}
Array.prototype.findIndex = Array.prototype.findIndex || function (fn, context) {
    if (typeof fn === "function") {
        for (var k = 0, length = this.length; k < length; k++) {
            if (fn.call(context, this[k], k, this)) {
                return k;
            }
        }
    }
    return -1;
};
if (!Array.prototype.find) {
    Array.prototype.find = function (predicate) {
        'use strict';
        if (this == null) {
            throw new TypeError('Array.prototype.find called on null or undefined');
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[1];
        var value;

        for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
                return value;
            }
        }
        return undefined;
    };
}
import BootstrapService from "./service/BootstrapService";

if (typeof(window.nonPOSPage) == 'undefined' || !window.nonPOSPage) {
    if (window.devicePixelRatio >= 1.5) {
        document.body.style.zoom = 0.85;
    }
    new BootstrapService().run();
}


// WEBPACK FOOTER //
// ./src/main.js